import * as yup from 'yup';

export const schema = yup
  .object({
    des_integracao: yup.string().required(),
    hash: yup.string().required(),
  })
  .required();
